import React from "react";
import ServicesSection from "../../components/ServicesSection/ServicesSection.jsx";

export default function ServicesPage() {
  return (
    <div>
      <ServicesSection />
      {/* Other components or content can be added here */}
    </div>
  );
}
